import { IThunderboltEntry } from '@wix/editor-elements-types';

import {
  registerComponentTypeUiTypes,
  UiTypesRegistrationMap,
} from '../../registration/registration';

const UiTypes: UiTypesRegistrationMap = {
  '': () => [
    import('./viewer/Freestyle' /* webpackChunkName: "Freestyle" */),
    import('./viewer/Freestyle.controller' /* webpackChunkName: "Freestyle" */),
  ],
};

const entry: IThunderboltEntry = {
  loadComponent: registerComponentTypeUiTypes('Freestyle', UiTypes),
};

export default entry;
